var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccentUnderline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 134.5709229 12.0052519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.3173428 1.7944679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.00 4.48 C 21.47 -1.12 103.16 -1.14 147.95 2.59",
    fill: "none",
    stroke: "#6326F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccentUnderline);
export default __webpack_public_path__ + "static/media/accent-underline.a57906ea15f944c0ff5ddbc6562aeac7.svg";
export { ForwardRef as ReactComponent };